import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators} from '@angular/forms';
import { ProductsService, RootService, CustomerService } from 'src/app/services';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {capitalizeFirstLetter, removeAllSpacingBetweenWords} from '../../../../helpers';
import {getDateHelper} from "../../../../shared/common/helper";
@Component({
  selector: 'app-customers-group-update',
  templateUrl: './customers-group-update.component.html',
  styleUrls: ['./customers-group-update.component.scss']
})
export class CustomersGroupUpdateComponent implements OnInit {
  unsubscribe$ = new Subject<void>();
  id;
  show = false;
  // select product
  productValue = '1';
  showInputProduct = false;
  listOfSelectedValueProduct = [];
  productName = '';
  total;
  products = [];
  isLoading = false;
  searchProductChange$ = new BehaviorSubject('');
  // end select product

  // select khu vuc
  cityValue = '1';
  showInputCity = false;
  cities = [];
  listOfSelectedValueCity = [];
  // end select khu vuc
  validName = false;
  messageName;
  validProduct = false;
  messageProduct$;
  validCity = false;
  messageCity$;
  @Output() emitData = new EventEmitter();
  loading = false;
  constructor(
    private fb: FormBuilder,
    private  productsService: ProductsService,
    private notification: NzNotificationService,
    private rootService: RootService,
    private customerService: CustomerService,
  ) {
    const optionListProduct$: Observable<string> = this.searchProductChange$
      .asObservable()
      .pipe(debounceTime(500));
    optionListProduct$.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      // @ts-ignore
      // tslint:disable-next-line:triple-equals
      if (this.productValue == 2) {

        const query = {
          product_name: value.trim(),
          page: 1,
          page_size: 50
        };
        this.productsService.getAll(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
          (res) => {
            const data = res.data.items;
            if (data != null) {
              data.map(item => {
                const product = {
                  id: undefined,
                  name: undefined
                };
                if (!this.listOfSelectedValueProduct.includes(item.productId)) {
                  if (item.productName) {
                    product.id =  item.productId;
                    product.name = item.productName + ' ' + '(' + item.barcode + ')';
                  } else {
                    product.id =  item.productId;
                    product.name = '(' + item.barcode + ')';
                  }
                  this.products.push(product);
                }
              });
            }
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
            this.products = [];
          }
        );
      }
    });
  }
  // tslint:disable-next-line:variable-name
  form_update = this.fb.group({
    name: ['', [Validators.required]],
    date: '',
  });
  getDate(date) {
    return getDateHelper(date);
  }
  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
  }
  getInfoGroup() {
    this.customerService.getGroupById(this.id).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.show = true;
          this.showInputProduct = false;
          this.showInputCity = false;
          this.form_update.reset();
          const data = res.data;
          this.form_update.get('name').setValue(data.name);
          if (data.isAllProduct && data.products.length === 0) {
            this.productValue = '1';
          } else {
            this.productValue = '2';
            this.showInputProduct = true;
            data.products.map(item => {
              this.listOfSelectedValueProduct.push(item.id);
              this.productsService.getAll({product_name: item.productName}).subscribe(
                res1 => {
                  const pro = res1.data.items;
                  if (pro != null) {
                    pro.map(i => {
                      const product = {
                        id: undefined,
                        name: undefined
                      };
                      if (i.productName) {
                        product.id =  i.productId;
                        product.name = i.productName + ' ' + '(' + i.barcode + ')';
                      } else {
                        product.id =  i.productId;
                        product.name = '(' + i.barcode + ')';
                      }
                      this.products.push(product);
                    });
                  }
                }
              );
            });
            this.searchProductChange$.next('');
          }
          if (data.isAllProvince && data.provinces.length === 0) {
            this.cityValue = '1';
          } else {
            this.cityValue = '2';
            this.showInputCity = true;
            data.provinces.map(item => {
              this.listOfSelectedValueCity.push(item.id);
            });
            this.loadCity();
          }
          const timeAt = data.timeAt.split('-');
          // tslint:disable-next-line:variable-name
          const timeAt_converted = [timeAt[1], timeAt[0], timeAt[2]].join('-');
          if (timeAt_converted.length >= 10) {
            this.form_update.get('date').setValue(timeAt_converted);
          }
        } else {
          this.notification.error(
            'Lấy thông tin nhóm đối tượng thất bại',
            res.mesage
          );
        }
      },
      error => {
        this.notification.error(
          'Lấy thông tin nhóm đối tượng thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }
  inputChange(event) {
    this[event] = false;
  }
  searchProduct(event) {
    this.products = [];
    this.isLoading = true;
    this.searchProductChange$.next(event);
  }
  productChange(event) {
    // tslint:disable-next-line:triple-equals
    if (event == 2) {
      this.products = [];
      this.searchProductChange$.next('');
      this.showInputProduct = true;
      return;
    }
    this.showInputProduct = false;
  }
  cityChange(event) {
    // tslint:disable-next-line:triple-equals
    if (event == 2) {
      this.loadCity();
      this.showInputCity = true;
      return;
    }
    this.showInputCity = false;
  }
  loadCity() {
    this.rootService.listCities().subscribe(
      res => {
        this.cities = res.data.items;
      },
      error => {
        this.cities = [];
      }
    );
  }
  isNotSelectedCity(value: string): boolean {
    return this.listOfSelectedValueCity.indexOf(value) === -1;
  }
  changeSelectValue(event) {
    this[event] = false;
  }
  // ==============end khu vuc=============//
  update() {
    // tslint:disable-next-line:forin
    for (const i in this.form_update.controls) {
      this.form_update.controls[i].markAsDirty();
      this.form_update.controls[i].updateValueAndValidity();
    }
    if (this.form_update.invalid) {
      return;
    }
    this.validName = false;
    const data = this.form_update.value;
    if (data.name.trim().length === 0) {
      this.messageName = 'Tên nhóm đối tượng không hợp lệ';
      this.validName = true;
    }
    if (data.name.trim().length > 255) {
      this.messageName = 'Tên nhóm đối tượng không quá 255 ký tự';
      this.validName = true;
    }
    const body = {
      name: capitalizeFirstLetter(removeAllSpacingBetweenWords(data.name)),
      isAllProduct: true,
      productIds: [],
      isAllProvince: true,
      provinceIds: [],
      timeAt: data.date ? this.getDate(data.date) : '',
    };
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (this.productValue != 1) {
      if (this.listOfSelectedValueProduct.length > 0) {
        body.isAllProduct = false;
        body.productIds = this.listOfSelectedValueProduct;
        this.validProduct = false;
      } else {
        this.validProduct = true;
        this.messageProduct$ = 'Chưa chọn sản phẩm';
      }
    } else {
      this.validProduct = false;
    }
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (this.cityValue != 1) {
      if (this.listOfSelectedValueCity.length > 0) {
        this.validCity = false;
        // tslint:disable-next-line:triple-equals
        if (this.listOfSelectedValueCity.length != this.cities.length) {
          body.isAllProvince = false;
          body.provinceIds = this.listOfSelectedValueCity;
        }
      } else {
        this.validCity = true;
        this.messageCity$ = 'Chưa chọn khu vực';
      }
    } else {
      this.validCity = false;
    }
    if (this.validName || this.validProduct || this.validCity) {
      return;
    }
    this.loading = true;
    this.customerService.updateGroup(this.id, body).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.notification.success(
            'Thành công',
            'Cập nhật đối tượng thành công'
          );
          setTimeout(() => {
            this.show = false;
          }, 500);
          this.emitData.emit(res.code);
          return;
        }
        this.notification.error(
          'Cập nhật đối tượng thất bại',
          res.message
        );
      },
      error => {
        this.loading = false;
        this.notification.error(
          'Cập nhật đối tượng thất bại',
          'Hệ thống đang nâng cập.Vui lòng thử lại sau'
        );
      }
    );
  }
  showModal(id) {
    this.products = [];
    this.cities = [];
    this.listOfSelectedValueCity = [];
    this.listOfSelectedValueProduct = [];
    this.id = id;
    this.validName = this.validProduct = this.validCity = false;
    this.getInfoGroup();
  }
  hideModal() {
    this.loading = false;
    this.show = false;
    this.form_update.reset();
  }
  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
